import { Box, styled } from '@mui/material';
import { PrimaryLinkButton } from 'apps/wrapper/src/components/shared/buttons/buttons.styles';

export const GeneralPatientInfoBlockWrapper = styled(Box)({
  display: 'flex',
  flexDirection: 'row',
  lineHeight: '160%',
  letterSpacing: '0.15px',
  margin: '0 20px'
});

export const GeneralPatientInfoBlock = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  marginTop: '15px'
});

export const PatientName = styled(Box)({
  display: 'flex',
  fontSize: '16px',
  fontWeight: 500,
  alignItems: 'center'
});

export const PatientNameButton = styled(PrimaryLinkButton)({
  fontSize: '16px',
  fontWeight: 500,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  padding: 0,
  textTransform: 'none'
});

export const PatientInfoList = styled('ul')({
  display: 'flex',
  flexDirection: 'row',
  listStyle: 'none',
  padding: 0,
  fontSize: '12px',
  margin: '2px 2px 2px 5px'
});

export const PatientInfoListItem = styled('li')({
  display: 'flex',
  fontSize: '12px',
  margin: '0 5px 0 0',
  '&::after': {
    content: '"•"',
    marginLeft: '4px',
    color: 'black'
  },
  '&:last-of-type': {
    '&::after': {
      content: '""'
    }
  }
});

export const PatientEmail = styled(Box)({
  display: 'flex',
  fontSize: '12px',
  marginLeft: '5px'
});

export const DetailsSection = styled(Box)({
  display: 'flex'
});

export const PatientActionsWrapper = styled(Box)({
  display: 'flex',
  margin: '10px 0 0 auto'
});
